/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Represents an issue that puts a person in the Needs attention tab: a
 * student's failed charge or balance owed; a parent, or a student with no
 * parent, with no card or bank on file; a tutor paid through Tadpole
 * payroll with no payroll bank; a student's open meeting request; a task
 * due about the person.
 */
export enum AttentionIssue {
  CHARGE_FAILED = "charge_failed",
  OWES = "owes",
  NO_PAYMENT_METHOD = "no_payment_method",
  NO_PAYROLL_BANK = "no_payroll_bank",
  MEETING_REQUEST = "meeting_request",
  TASK_DUE = "task_due",
}
